<div class="text-container">
    <h4 class="dialog-title">{{ data.title | locale}}</h4>
    <p class="countdown">{{ data.message1 | locale }} <span class="countdown-text" color="#C5FF00">{{ countdownText }}</span> {{ data.message2 | locale }}</p>
    <p><b>{{ data.message3 | locale }}</b></p>
</div>
